"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "olgiate-molgora": {
    "20ac0e17": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "skipSearch": false
    }],
    "beolco": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b3675014": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "skipSearch": false
    }],
    "buttero": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d4491231": [{
      "hkey": "e6c355a7",
      "slug": "canova-san-zeno",
      "name": "Canova-San Zeno",
      "primary": true,
      "skipSearch": false
    }],
    "canova": [{
      "hkey": "e6c355a7",
      "slug": "canova-san-zeno",
      "name": "Canova-San Zeno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0581171d": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "skipSearch": false
    }],
    "monastirolo": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e0bdecc5": [{
      "hkey": "55b3b88c",
      "slug": "monticello-mondonico",
      "name": "Monticello-Mondonico",
      "primary": true,
      "skipSearch": false
    }],
    "mondonico": [{
      "hkey": "55b3b88c",
      "slug": "monticello-mondonico",
      "name": "Monticello-Mondonico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olgiate-molgora"
    }],
    "36fece66": [{
      "hkey": "55b3b88c",
      "slug": "monticello-mondonico",
      "name": "Monticello-Mondonico",
      "primary": true,
      "skipSearch": false
    }],
    "monticello": [{
      "hkey": "55b3b88c",
      "slug": "monticello-mondonico",
      "name": "Monticello-Mondonico",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "b740e6bf": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "skipSearch": false
    }],
    "olgiate-vecchio": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a1657630": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "skipSearch": false
    }],
    "porchera": [{
      "hkey": "7c42fa1b",
      "slug": "olgiate-molgora",
      "name": "Olgiate Molgora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d2eea8bf": [{
      "hkey": "e6c355a7",
      "slug": "canova-san-zeno",
      "name": "Canova-San Zeno",
      "primary": true,
      "skipSearch": false
    }],
    "san-zeno": [{
      "hkey": "e6c355a7",
      "slug": "canova-san-zeno",
      "name": "Canova-San Zeno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "olgiate-molgora"
    }]
  }
};
exports["default"] = _default;